export default {
    data: () => ({
        translations: {
            title: {
                el: "API Authentication",
                en: "API Authentication",
                it: "API Authentication"
            },
            password: {
                el: "Κωδικός",
                en: "Password",
                it: "Codice"
            },
            getToken: {
                el: "Απέκτησε Token",
                en: "Get Token",
                it: "Get Token"
            },
            detailedDocumentation: {
                el: "Μπορείτε να βρείτε λεπτομερή τεκμηρίωση",
                en: "You can find detailed documentation",
                it: "Potete trovare la documentazione dettagliata"
            },
            here: {
                el: "εδώ",
                en: "here",
                it: "qui"
            },
            resetPreviously: {
                el: "Επαναφορά όλων των tokens που έχουν δημιουργηθεί προηγουμένως",
                en: "Reset all previously created tokens:",
                it: "Azzerare tutti i token creati in precedenza"
            }
        }
    })
};
